import React from 'react'
import PrivateRoute from '../../PrivateRoute'
import { Switch } from 'react-router-dom'
import Form from './form'
import Grid from './grid'
import { OutorgaContextProvider } from '../../../contexts/Outorga'

const Outorga = () => (
    <OutorgaContextProvider>
        <div className='hdv-render-div'>
            <div className="col-md-12 hdv-bloco-top-space hdv-zera-padding-left-right-boostrap">
                <Switch>
                    <PrivateRoute exact path='/ambiental/outorga' component={Grid} />
                    <PrivateRoute path='/ambiental/outorga/novo' component={Form} />
                    <PrivateRoute path='/ambiental/outorga/:id/editar' component={Form} />
                </Switch>
            </div>
        </div>
    </OutorgaContextProvider>
)

export default Outorga